/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
// Common
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Navigate } from "react-router-dom";
//Icon Library
//Auth
import { isAuthenticated } from "./services/auth.js"; //import auth
//Loading
import LoadingSpinner from "../LoadingSpinner";
import AdminClassViewer from "./AdminClassViewer";
import AdminBlockViewer from "./AdminBlockViewer";
import AdminAlerts from "./page-parts/AdminAlerts";

const OverviewPage = () => {
  // Manage State
  const [classes, setClasses] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Get the overview list of classes.
 

  // Load them on mount
  useEffect(() => {
    async function getData () {
      const getData = await axios.get(`/api/admin/manage/overview/`, {
        withCredentials: true,
      });
      setBlocks(getData.data.blockData);
      setClasses(getData.data.classData);
      return setIsLoading(false);
    }
    getData();
  }, []);
  
  return (
    <div className='OverviewClassViewer'>
       {isAuthenticated() ? (
      <FadeIn delay={250} duration={450}>
          <div>
           <AdminAlerts />
           {classes && <AdminClassViewer classes={classes}/>}
           {blocks && <AdminBlockViewer blocks={blocks}/>}
           {isLoading && <LoadingSpinner />}
           {!isLoading && blocks.length === 0 && classes.length === 0 && <NoClassesMessage/>}
          </div>
          </FadeIn>
        ) : (
          <Navigate to='/admin/' />
      )}
    </div>
  );
};

const NoClassesMessage = () => {
  return <div>
    <h3 className="text-center mt-3 mb--3">...No classes or blocks set up...</h3>
  </div>
}

export default OverviewPage;
